import { createSlice } from "@reduxjs/toolkit";
import { actionTypes } from "../../../../Auth/_redux/authRedux";
import {
  AgentStatusOptions,
  CustomerStatusOptions,
  DeviceOptions
} from "./FiltersConstants";

const initialListingsState = {
  searchColumns: [],
  callsTableFilters: {
    solutionOptions: [{ label: "IBD CC", value: "IBD CC" }],
    selectedSolutions: [],
    selectedSolutionOptions: [],
    agentStatusOptions: AgentStatusOptions,
    selectedAgentStatusOptions: [],
    selectedAgentStatus: [],
    deviceOptions: DeviceOptions,
    selectedDeviceOptions: [],
    selectedDevice: [],
    customerStatusOptions: CustomerStatusOptions,
    selectedCustomerStatusOptions: [],
    selectedCustomerStatus: [],
    selectedSrNumberOptions: [],
    selectedSrNumber: [],
    selectedQueueOptions: [],
    selectedQueue: [],
  },
  appliedFiltersSelections: {},
  agentsList: [],
  liveCallsSearchInput: null,
};

export const callMonitoringCallsSlice = createSlice({
  name: "callMonitoringCallsSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });
  },

  reducers: {
    setCallsTableConfigureColumns: (state, action) => {
      state.searchColumns = action.payload;
    },
    setLiveCallMonitorFilters: (state, action) => {
      state.callsTableFilters = {
        ...state.callsTableFilters,
        ...action.payload["changelog"],
      };
    },

    clearLiveCallMonitorFilters: (state, action) => {
      let changelog = {};
      changelog.selectedSolutions = [];
      changelog.selectedSolutionOptions = [];
      changelog.selectedAgentStatus = [];
      changelog.selectedAgentStatusOptions = [];
      changelog.selectedDevice = [];
      changelog.selectedDeviceOptions = [];
      changelog.selectedCustomerStatus = [];
      changelog.selectedCustomerStatusOptions = [];
      changelog.selectedQueue = [];
      changelog.selectedQueueOptions = [];
      changelog.selectedSrNumber = [];
      changelog.selectedSrNumberOptions = [];
      state.callsTableFilters = {
        ...state.callsTableFilters,
        ...changelog,
      };
    },

    applyLiveCallsTableFilters: (state, action) => {
      var newState = { ...state.appliedFiltersSelections };
      if (action.payload["changelog"]) {
        newState["call_type"] =
          action.payload["changelog"]["selectedSolutions"];
        newState["agent_status"] =
          action.payload["changelog"]["selectedAgentStatus"];
        newState["customer-status"] =
          action.payload["changelog"]["selectedCustomerStatus"];
        newState["CC-SR-Number"] =
          action.payload["changelog"]["selectedSrNumber"];
        newState["queue_name"] = action.payload["changelog"]["selectedQueue"];
        newState["sip_url_flag"] =
          action.payload["changelog"]["selectedDevice"];
      }
      state.appliedFiltersSelections = {
        ...state.appliedFiltersSelections,
        ...newState,
      };
    },

    clearLiveCallsTableAppliedFilters: (state, action) => {
      var newClearedState = { ...state.appliedFiltersSelections };
      Object.keys(newClearedState).map((key) => {
        newClearedState[key] = [];
      });
      state.appliedFiltersSelections = {
        ...state.appliedFiltersSelections,
        ...newClearedState,
      };
    },

    setLiveCallsSearchValue: (state, action) => {
      state.liveCallsSearchInput = action.payload;
    },
  },
});

export const {
  setCallsTableConfigureColumns,
  setLiveCallMonitorFilters,
  applyLiveCallsTableFilters,
  clearLiveCallMonitorFilters,
  setLiveCallsSearchValue,
  clearLiveCallsTableAppliedFilters,
} = callMonitoringCallsSlice.actions;
